import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { episodeChapters } from '../data/abbviePro';
import { AbbVieHeroPlayer } from './AbbVieHeroPlayer';
const principles = ['Preserve existing AbbVie Pro navigation and compliance pathways', 'Reveal definitions and evidence only when requested', 'Keep clinical information legible and easy to scan'];
export function AbbVieEvidenceScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-white px-6 py-20" aria-labelledby="evidence-title" data-id="element-47" data-mp="euxon31blt18">
      <div className="mx-auto grid w-full max-w-7xl gap-12 lg:grid-cols-[0.72fr_1.28fr] lg:items-center" data-id="element-48" data-mp="a3fpmkiuy2iw">
        <div data-id="element-49" data-mp="54mkpghmzjuc">
          <p className="mb-4 text-sm font-semibold text-primary" data-id="element-50" data-mp="554dg353bfxi">09 — Embedded example</p>
          <h2 id="evidence-title" className="text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-51" data-mp="12mctb2gkkmfn">Depth without overload</h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-500" data-id="element-52" data-mp="xs8put6iiwjb">The hero player lives inside the familiar AbbVie Pro product page. When the episode ends, users branch naturally into the full clinical library below.</p>
          <ul className="mt-8 space-y-4" data-id="element-53" data-mp="2xerr0pjknx5k">
            {principles.map(principle => <li key={principle} className="flex gap-3 text-sm leading-relaxed text-slate-600" data-id="element-54" data-mp="32d3191ds49ob">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sky-100 text-abbvie-cyan" data-id="element-55" data-mp="2odtm851b7llx"><CheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-56" data-mp="2sfoobbr2e30r" /></span>
                {principle}
              </li>)}
          </ul>
          <p className="mt-8 text-sm italic text-slate-400" data-id="element-57" data-mp="2eh8iro4xuik7">SKYRIZI is the worked example — the same hero embed model applies to any AbbVie Pro therapeutic area.</p>
        </div>

        <motion.div initial={reduceMotion ? false : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-58" data-mp="cpc2k17tskj3">
          <AbbVieHeroPlayer chapters={episodeChapters} exampleLabel="SKYRIZI · clinical evidence example" videoSrc="https://cdn.magicpatterns.com/uploads/71cULznisVDNvRu1Ts6ikK/main.mp4" videoStartTime={30} data-id="element-59" data-mp="g6q221kc4xir" />
        </motion.div>
      </div>
    </section>;
}